import React from 'react';
import ReactDOM from 'react-dom';
import './Styles/index.less';
import App from './App';
// import * as serviceWorker from './serviceWorker';

function onNumberInputWheel(e) {
  e.target.blur();
}

function onNumberInputKeyDown(e) {
  if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
    e.preventDefault();
    e.stopImmediatePropagation();
  }
}

document.addEventListener('focusin', (e) => {
  const isNativeNumber = e.target.type === 'number';
  const isAntInputNumber = e.target.classList.contains(
    'ant-input-number-input',
  );
  if (isNativeNumber || isAntInputNumber) {
    e.target.addEventListener('keydown', onNumberInputKeyDown, {capture: true});
  }
  if (isNativeNumber) {
    e.target.addEventListener('wheel', onNumberInputWheel);
  }
});

document.addEventListener('focusout', (e) => {
  const isNativeNumber = e.target.type === 'number';
  const isAntInputNumber = e.target.classList.contains(
    'ant-input-number-input',
  );
  if (isNativeNumber || isAntInputNumber) {
    e.target.removeEventListener('keydown', onNumberInputKeyDown, {
      capture: true,
    });
  }
  if (isNativeNumber) {
    e.target.removeEventListener('wheel', onNumberInputWheel);
  }
});

ReactDOM.render(
  <>
    <App />
  </>,
  document.getElementById('root'),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
// serviceWorker.unregister();
// serviceWorker.register();
// const url = `${process.env.PUBLIC_URL}/OneSignalSDKWorker.js`;
// navigator.serviceWorker.register('/OneSignalSDKWorker.js');
// navigator.serviceWorker.register('/OneSignalSDKUpdaterWorker.js');
